import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteControlTask } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_TASKS.DELETE,
  api: deleteControlTask,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlTasks/DeleteAction.js